export const DASHBOARD = '/';
export const ADD_CARD = '/:username/:language';
export const CHECKOUT = '/checkout/:status';
export const PROFILE = '/';
